import React, { FC } from 'react';
import cn from 'classnames';

import { cleanBuilderStringInput, getBuilderString } from '@/shared/text';

import { ImageLot } from './types';
import style from './ImageItem.module.scss';
import { Action } from '../Action';

interface Props {
  locale: string;
  item: ImageLot;
}

export const ImageItem: FC<Props> = ({ locale, item }) => (
  <article className={style.imageItem}>
    <div className={cn(style.card)}>
      <div
        className={cn(style.content, 'u-p-l')}
        style={{
          backgroundImage: `url(${cleanBuilderStringInput(
            getBuilderString(item.imageUrl, locale),
            true
          )})`,
        }}
      />
    </div>
    <Action
      className={cn(style.action)}
      locale={locale}
      label={item.actionLabel}
      url={item.actionUrl}
      variant={item.actionVariant}
    />
  </article>
);
